export default __webpack_public_path__ + "static/media/trafalgar.2fcf3d90.svg";